import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import CircleIcon from '@mui/icons-material/Group';
import RecommendationsIcon from '@mui/icons-material/Stars';
import AddReviewIcon from '@mui/icons-material/RateReview';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';

const NavBar = ({ authenticatedUser, handleLogout, showNotificationsEnabler, requestNotificationPermission }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = () => {
        handleMenuClose();
        handleLogout();
    };

    const handleRequestNotificationPermission = () => {
        handleMenuClose();
        requestNotificationPermission();
    };

    return (
        <AppBar position="fixed" sx={{height:'56px', backgroundColor:'black'}}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={handleMenuClick}
                >
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                    Flickers
                </Typography>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleMenuClose} component={Link} to="/">
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inicio" />
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/circle">
                        <ListItemIcon>
                            <CircleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Mi círculo" />
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/recommendations">
                        <ListItemIcon>
                            <RecommendationsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Recomendaciones" />
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/addreview">
                        <ListItemIcon>
                            <AddReviewIcon />
                        </ListItemIcon>
                        <ListItemText primary="Recomendar" />
                    </MenuItem>
                    {authenticatedUser && showNotificationsEnabler && (
                        <MenuItem onClick={handleRequestNotificationPermission}>
                            <ListItemIcon>
                                <NotificationsIcon />
                            </ListItemIcon>
                            <ListItemText primary="Habilitar Notificaciones" />
                        </MenuItem>
                    )}
                    {authenticatedUser ? (
                        <MenuItem onClick={handleLogoutClick}>
                            <ListItemIcon>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary="Cerrar sesión" />
                        </MenuItem>
                    ) : null}
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;
